import { createRoot } from 'react-dom/client';
import { when } from 'mobx';
import { InteractionType } from '@azure/msal-browser';
import { MsalProvider, MsalAuthenticationTemplate } from '@azure/msal-react';
import { AnchorConfig } from '@anchor-ds/react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { environmentStore } from './store/EnvironmentStore';
import { LoadingScreen } from './components/loading-screen';
import { App } from './App';

import './index.scss';

dayjs.extend(utc);

environmentStore.load();

when(
  () => environmentStore.loaded,
  () => {
    const container = document.getElementById('root');
    const root = createRoot(container);

    root.render(
      <AnchorConfig theme="dark" className="anchor-root">
        <MsalProvider instance={environmentStore.msal}>
          <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={{
              ...environmentStore.getAuthParameters(),
              redirectStartPage: window.location.origin,
            }}
            loadingComponent={() => <LoadingScreen />}
          >
            <App />
          </MsalAuthenticationTemplate>
        </MsalProvider>
      </AnchorConfig>
    );
  }
);
